import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PaginationStateService {
  private readonly prefix = 'pagination_';

  saveState(key: string, page: number, pageSize: number): void {
    localStorage.setItem(`${this.prefix}${key}`, JSON.stringify({ page, pageSize }));
  }

  loadState(key: string): { page: number; pageSize: number } | null {
    const data = localStorage.getItem(`${this.prefix}${key}`);
    return data ? JSON.parse(data) : null;
  }

  clearState(key: string): void {
    localStorage.removeItem(`${this.prefix}${key}`);
  }
}
